/**
 * Query key factory for labour definition queries
 * Following react-query-patterns.md
 *
 * Ensures consistent cache invalidation when:
 * - Creating new labour item definitions
 * - Deleting labour item definitions
 */
export const labourDefinitionKeys = {
  all: ['labourDefinitions'] as const,
  lists: () => [...labourDefinitionKeys.all, 'list'] as const,
};
